'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'cart-shopping';
var width = 640;
var height = 512;
var aliases = [128722,"shopping-cart"];
var unicode = 'f07a';
var svgPathData = 'M0 8C0-5.3 10.7-16 24-16l45.3 0c27.1 0 50.3 19.4 55.1 46l.4 2 399.9 0c25.1 0 44 22.9 39.3 47.6L537.6 216.6c-8 41.4-44.2 71.4-86.4 71.4l-279.8 0 5.1 28.3c2.1 11.4 12 19.7 23.6 19.7L456 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-255.9 0c-34.8 0-64.6-24.9-70.8-59.1L77.2 38.6c-.7-3.8-4-6.6-7.9-6.6L24 32C10.7 32 0 21.3 0 8zM162.6 240l288.6 0c19.2 0 35.7-13.6 39.3-32.4L514.9 80 133.5 80 162.6 240zM208 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm224 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCartShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;